<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')" />
    <MenuHealthCompact v-else />

    <div class="px-6 surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
                        <li class="pr-3"><a class="cursor-pointer">Account</a></li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Application Store</a>
                        </li>
                    </ul>

                    <h3>Application Store</h3>

                    <div style="height: 8px;"></div>

                    <div class="grid -mt-3 -ml-3 -mr-3">

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">
                                    <div class="relative mb-3">
                                        <img src="images/appstore/logo.privatepractice.png" class="w-full"/>
                                    </div>
                                    <div class="flex justify-content-between align-items-center mb-3">
                                        <span class="text-900 font-medium text-xl">Private Practice 101</span>
                                        <span>
                                            <i class="pi pi-star-fill text-yellow-500 mr-1"></i>
                                            <span class="font-medium">5.0</span>
                                        </span>
                                    </div>
                                    <p><span class="text-900">Application</span></p>
                                    <p class="mt-0 mb-3 text-600 line-height-3">
                                        If you're looking to start or build your private practice, our Private Practice
                                        Education Software
                                        is your step-by-step guide to highlighting your path to success.
                                    </p>

                                    <Button v-if="this.userConfiguration.enableAppstoreApp1 === 'Y'" label="Access" class="w-full" @click="processAccessApplication001"></Button>
                                    <Button v-else label="R997" class="w-full" @click="processPurchaseApplication001"></Button>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">
                                    <div class="relative mb-3">
                                        <img src="images/appstore/logo.cpd.module.png" class="w-full"/>
                                    </div>
                                    <div class="flex justify-content-between align-items-center mb-3">
                                        <span class="text-900 font-medium text-xl">IsoEvolve CPD Application #1</span>
                                        <span>
                                            <i class="pi pi-star-fill text-yellow-500 mr-1"></i>
                                            <span class="font-medium">5.0</span>
                                        </span>
                                    </div>
                                    <p><span class="text-900">Course</span></p>
                                    <p class="mt-0 mb-3 text-600 line-height-3">
                                        31 CPD Points (including 6 ethics points) that includes topics on Modalities of
                                        Therapy,
                                        ADHD, Disorders and Private Practice Management.
                                    </p>

                                    <Button v-if="this.userConfiguration.enableAppstoreApp2 === 'Y'" label="Access" class="w-full" @click="processAccessApplication002"></Button>
                                    <Button v-else label="R495" class="w-full" @click="processPurchaseApplication002"></Button>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        await this.loadCompanyContext();
    },
    data() {

        return {
            profile: {},
            userConfiguration: {}
        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Appointments][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                // Attempt to get user data
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
                this.userStore.clearUser();
                this.$router.push('login');
                return;
            }

            this.profile.companyId = this.userStore.activeCompanyId;

            try {
                const [userConfigData] = await Promise.all([
                    UserService.getUserConfig(this.userStore.user.id)
                ]);

                this.userConfiguration = userConfigData.data;

                console.log("[Applications][mounted] userConfigData.data = ", userConfigData.data);
            } catch (e) {
                console.error("[Applications][mounted] Could not find user config for user = ", this.userStore.user.id);
                this.userConfiguration = {
                    enableAppstoreApp1: 'N',
                    enableAppstoreApp2: 'N',
                    enableAppstoreApp3: 'N',
                    enableAppstoreApp4: 'N',
                    enableAppstoreApp5: 'N',
                    enableAppstoreApp6: 'N',
                    enableAppstoreApp7: 'N',
                    enableAppstoreApp8: 'N',
                    enableAppstoreApp9: 'N',
                    enableAppstoreApp10: 'N',
                    enableAppstoreApp11: 'N'
                };
            }
        },
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        processAccessApplication001() {
            console.log("[ProfileApplicationStore][processAccessApplication001] Beginning.");
            this.safeNavigate('/commonApplication001');
        },
        processPurchaseApplication001() {
            console.log("[ProfileApplicationStore][processPurchaseApplication001] Beginning.");

            window.open(
                'https://buy.stripe.com/6oEcOw8Zr3HyaEE4io',
                '_blank' // <- This is what makes it open in a new window.
            );
        },
        processAccessApplication002() {
            console.log("[ProfileApplicationStore][processAccessApplication002] Beginning.");
            this.safeNavigate('/commonApplication002');
        },
        processPurchaseApplication002() {
            console.log("[ProfileApplicationStore][processPurchaseApplication001] Beginning.");

            window.open(
                'https://buy.stripe.com/dR6bKscbD1zq5kk4im',
                '_blank' // <- This is what makes it open in a new window.
            );
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
